

































































































































































































import {functions} from "@/scripts/firebase";
import { UserProfile,UserRole, NoticeProps, UserPublicProfile, UserPrivateProfile} from "@/scripts/datatypes";
import { Component,Watch ,Mixins} from "vue-property-decorator";
import Notice from "@/components/Notice.vue";
import ModalConfirm from "@/components/ModalConfirm.vue"

import Common from '@/mixins/common'
import { ValidationObserver } from 'vee-validate'
//import { ValidationResult } from 'vee-validate/dist/types/types';

//eslint-disable-next-line
const jaconv = require("jaconv")

/**
 * authデータ処理から
 * アカウント停止
 * 自分の権限より下のもののアカウントのみ停止にできる
 * 
 * 権限変更
 * 自分の権限以下のアカウントのみ権限変更(自分の権限以下)できる
 * 初期特権管理者(author==uid)アカウントは権限変更できない
 * 
 */
/**
 * アップロード画像の内容チェック ファイル形式 サイズ
 * エラー表示
 */

interface User {
  uid?: string;
	role?: string;
	accessLevel?: number;
	displayName?: string;
	lastName?: string;
	firstName?: string;
	lastNameYomigana?: string;
	firstNameYomigana?: string;
  disabled?: boolean;
  email?: string;
  lang?: string;
  profileImage?: string;
  emailVerified?: boolean;
  lastSignInTime?: firebase.default.firestore.Timestamp | string;
  updateTime?: firebase.default.firestore.Timestamp | string;
  creationTime?: firebase.default.firestore.Timestamp | string;
}

@Component({
  components: {
    Notice,
    ModalConfirm
  }
})

export default class EditUser extends Mixins(Common) {
  initialized = false
  isLoading = false
  isLoadingImage = false
  isDeletingImage = false
  profileImageSrc = ''
  profileImageNew = ''
  notice: NoticeProps = {}
  disabledUpdateProfile = true
  userMeta: User = {}
  uploadImageStatus = ''
  showModal = false
  modal = {title: 'editUser.deleteAccount',message: '', 'confirmText': 'editUser.deleteAccount',isLoading: false}

  userRolesAccessLevels: UserRole = {}

  get existUser(){
    if(Object.keys(this.userMeta).length > 0){
      return true
    }
    return false
  }

  @Watch('initialized',{immediate: true})
  changeInitializedStatus(newVal: boolean){
    if(! newVal){
      this.notice = {
        message: this.$t('editUser.loadingUserData') as string,
        isShow: true,
        duration: 0,
        type: {'is-info': true}
      }
    }else if(! this.existUser){
      this.notice = {
        message: this.$t('editUser.noUserFound') as string,
        isShow: true,
        duration: 0,
        type: {'is-danger': true}
      }
    }else{
      this.notice = {
        isShow: false,
      }
      this.modal.message = this.$t('editUser.deleleAccountDescription',{name: this.userMeta.displayName}) as string
    }
  }

  @Watch('userMeta',{deep: true})
  async changeUserMeta(newVal: User, oldVal: User){
    if(Object.keys(oldVal).length ==  0 ){
      return
    }

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = jaconv.toHiragana(jaconv.toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    this.disabledUpdateProfile = false
  }

  get theUid(){
    return this.$route.params.uid || ''
  }

  async deleteProfileImage(){
    this.uploadImageStatus = 'Deleting'
    this.profileImageSrc = ''
    const data = {
      profileImage: ''
    }

    await this.$updateDoc(this.$getUserPublicProfileDocRef(this.theUid), data)
    await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef(this.theUid))
    this.uploadImageStatus = ''
  }

  async uploadProfileImage(e: Event){
    if(! e.target){
      return
    }

    const target = e.target as HTMLInputElement

    if(! target.files){
      return
    }

    this.$store.commit('setLoading',true)
    this.isLoadingImage = true

    this.uploadImageStatus = 'Uploading....'

    //console.log(e.target.files)
    
    const file = target.files[0]
    this.profileImageNew = file.name

    try{
      const userImagesRef = this.$getUserImagesRef(this.theUid)
   
      const profileImageFileName = Date.now()
      const profileRef = userImagesRef.child(`profile/${profileImageFileName}`)
      
      await profileRef.put(file)
      this.uploadImageStatus = 'Generating Thumbnail'
      
      await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef(this.theUid))

      const profileImageThumbnailFileName = `${profileImageFileName}${this.$data.$profileThumbnailSize}`
      const profileThumbnailRef = userImagesRef.child(`profile/${profileImageThumbnailFileName}`)
      this.profileImageSrc = await profileThumbnailRef.getDownloadURL()
      this.uploadImageStatus = ''
    }catch(error){
      const errorCode = this.$getErrorCode(error)

      //const errorMessage0 = this.$t('resetPassword.error') as string
      
      const errorMessage1 = this.$getErrorMessage(errorCode)
      
      this.uploadImageStatus = errorMessage1
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoadingImage = false
    }
  }

  mounted(){
    console.log('mounted');
  }

  get observer(){
    return this.$refs.editUserValidationObserver as InstanceType<typeof ValidationObserver>
  }

  async created() {
    console.trace('created')

    try{
      this.$store.commit('setLoading',true)
      this.isLoading = true

      const getUserRolesAccessLevels = async (schoolId: string) => {
        const http = functions.httpsCallable('getUserRolesAccessLevels')
        let data = {}
        const accessLevels = await http({schoolId: schoolId})
        if(accessLevels.data){
          data = accessLevels.data
        }
        return Promise.resolve(data) as Promise<UserRole>
      }

      const getUserPublicProfile = async (uid: string) => {
        const ref = await this.$getUserPublicProfileDocRef(uid).get()
        let data = {}
        if(ref.exists){
          data = ref.data() as UserPublicProfile
        }
        return Promise.resolve(data) as Promise<UserPublicProfile>
      }

      const getUserPrivateProfile = async (uid: string) => {
        const ref = await this.$getUserPrivateProfileDocRef(uid).get()
        let data = {}
        if(ref.exists){
          data = ref.data() as UserPrivateProfile
        }
        return Promise.resolve(data) as Promise<UserPrivateProfile>
      }

      const getUserAuth = async (uid: string, schoolId: string) => {
          const id = {identifiers: [{uid: uid}], schoolId: schoolId}
          const http = functions.httpsCallable('getUsers');
          const users = await http(id)
          let data: UserProfile = {}
          if(users.data && users.data[this.theUid]){
            data = users.data[this.theUid]
            console.table(data)
            Object.keys(data).forEach((key) => {
              if(! ['email','emailVerified'].includes(key)){
                delete data[key as keyof UserProfile]
              }
            })
          }
          return Promise.resolve(data) as Promise<UserProfile>
        }

      console.time('xxx')

      const [userRolesAccessLevels,userPublicProfile,userPrivateProfile,userAuth  ] = await Promise.all([
        getUserRolesAccessLevels(this.$store.getters.schoolId),
        getUserPublicProfile(this.theUid),
        getUserPrivateProfile(this.theUid),
        getUserAuth(this.theUid,this.$store.getters.schoolId)
      ])


      console.timeEnd('xxx')

      this.userRolesAccessLevels = userRolesAccessLevels

      this.userMeta = {...userAuth,...userPublicProfile,...userPrivateProfile}

      if(this.userMeta.profileImage){
        this.isLoadingImage = true
        const profileImageFileName = `${this.userMeta.profileImage}${this.$data.$profileThumbnailSize}`

        const userImagesRef = this.$getUserImagesRef(this.theUid)
      
        const profileRef = userImagesRef.child(`profile/${profileImageFileName}`)

        this.profileImageSrc = await profileRef.getDownloadURL()
      }
    
    }catch(error){
      //console.log(error)
    }finally{
      this.$store.commit('setLoading',false)
      this.isLoadingImage = false
      this.isLoading = false
      this.initialized = true
    }
    
  }

  get languages(): string[]{
    if(this.$i18n.availableLocales){
      return this.$i18n.availableLocales
    }
    return [];
  }

  get roles(): string[]{
    const roles = Object.keys(this.userRolesAccessLevels)
    return roles
    /*
    return roles.sort((a,b) => {
      const uLa = this.userRolesAccessLevels[roles[a as any]]
      const uLb = this.userRolesAccessLevels[roles[b as any]]
      return uLa.accessLevel - uLb.accessLevel
    })
    */
  }

  async updateProfile(){
    try{
      this.notice = {
				isShow: false,
      }
			
			if(await this.observer.validate()){
			
        const updateFields = {...this.userMeta}
        let field: keyof User
        for (field in updateFields) {
          if(! this.observer.fields[field] || this.observer.fields[field].dirty === false || this.observer.fields[field].changed === false) {
            delete(updateFields[field])
          }
        }

        console.table(updateFields)
        
        if(Object.keys(updateFields).length > 0){

          this.$store.commit("setLoading",true);
          this.isLoading = true

          if(typeof updateFields.email === 'string' || typeof updateFields.displayName === 'string' || typeof updateFields.role === 'string' || typeof updateFields.disabled === 'boolean'){
            const updateUser = functions.httpsCallable('updateUser');

            const data = {
              ...updateFields,
              uid: this.theUid,
              schoolId: this.$store.getters.schoolId
            }

            const theUserData = await updateUser(data)

            if(this.$store.getters.uid === theUserData.data.uid){
              this.$store.commit("setUser",theUserData.data);
            }

            if(typeof updateFields.email === 'string'){
              this.userMeta.emailVerified = theUserData.data.emailVerified
            
              try{
                const sendMail = functions.httpsCallable('sendEmail');
                const data = {
                  uid: this.theUid,
                  schoolId: this.$store.getters.schoolId,
                  actionType: 'verifyEmail',
                  template: 'changedEmailMail'
                }

                await sendMail(data);
                delete updateFields.email
              /*
              if(sentMail.data){
                message += '<br />メールを送信しました'
              }
              */
              }catch(error){
                //
              }
            }
          }

          if(typeof updateFields.lang === 'string'){
            const updatePrivateProfile = {
              lang: updateFields.lang
            }
            await this.$updateDoc(this.$getUserPrivateProfileDocRef(this.theUid),updatePrivateProfile)
            await this.$waitUntilUpdatedForDoc(this.$getUserPrivateProfileDocRef(this.theUid))
            delete updateFields.lang
          }

          if(Object.keys(updateFields).length > 0){
            await this.$updateDoc(this.$getUserPublicProfileDocRef(this.theUid),updateFields)
            await this.$waitUntilUpdatedForDoc(this.$getUserPublicProfileDocRef(this.theUid))
          }

          this.notice = {
            message: this.$t('profile.updated') as string,
            isShow: true,
            type: {'is-success': true}
          }
          this.observer.reset()
        }else{
          this.notice = {
            message: this.$t('profile.noChangedFields') as string,
            isShow: true,
            type: {'is-info': true}
          }
        }
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$getErrorMessage(errorCode)

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
      
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateProfile = true
    }
  }

  async deleteUser(confirm: boolean){
    if(confirm){
      if(this.theUid !== this.$store.getters.uid && this.$store.getters.accessLevel === 10){
          this.$store.commit("setLoading",true)
          this.$set(this.modal,'isLoading',true)
          try{
            const deleteUser = functions.httpsCallable('deleteUser');
            await deleteUser({uid: this.theUid, schoolId: this.$store.getters.schoolId});
            this.userMeta = {}
            this.userMeta = {}
            this.notice = {
              message: this.$t('editUser.deletedAccount') as string,
              isShow: true,
              type: {'is-success': true}
            }
          }catch(error){
            const errorCode = this.$getErrorCode(error)
            const errorMessage = this.$getErrorMessage(errorCode)
            this.notice = {
              message: errorMessage,
              isShow: true,
              duration: 0,
              deleteButton: true,
              type: {'is-danger': true}
            }
          }finally{
            this.showModal = false
            this.$store.commit("setLoading",false);
            this.$set(this.modal,'isLoading',false)
          }
      }else{
        this.showModal = false
        this.notice = {
          message: this.$t('editUser.notAuthorized') as string,
          isShow: true,
          type: {'is-danger': true}
        }
      }
    }else{
      this.showModal = false
    }
  }


}
/*
 public async linkGoogleAuth(){
  const provider = new authObject.GoogleAuthProvider();
  const user = auth.currentUser;
  if(user == null){
    return;
  }
  
  try{
      await user.linkWithRedirect(provider);
  }catch(error) {
    console.log('linkGoogleAuth failed',error.code, error.message);
  }
 }

 */
